import styled, { keyframes } from 'styled-components/macro';

export const RowLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 25px;
`;

export const RowRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-right: 25px;
`;

export const RowCenter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const RowBetween = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ColumnCenter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Button = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: transparent;
  -webkit-tap-highlight-color: transparent;

  border-radius: 5px;
  border: 1px solid #000000;
  padding: 12px 15px;
  width: fit-content;
  font-family: Inter-Regular, Inter;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
`;

export const OptionDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: transparent;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;

  border-radius: 23px;
  border: 1px solid #11202B;
  padding-left: 20px;
  padding-right: 20px;
  height: 42px;
  width: fit-content;
`;

export const OptionInput = styled.input`
  font-family: Squad-Regular, Squad;
  font-weight: 400;
  font-size: 16px;
  color: #11202B;
  border: none;
  background: transparent;
`;

const fadeToBlack = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 100;
  position: fixed;
  animation: ${fadeToBlack} 0.3s ease-in-out;
  overflow: scroll;
`;
